import numberFormat from './numberFormat'

export interface PercentageFormatOptions extends Omit<Intl.NumberFormatOptions, 'style'> {
  isRatio?: boolean
}

const percentageFormat = (value: number, config: PercentageFormatOptions = {}): string => {
  if (Number.isNaN(value) || isNaN(value)) {
    return '0%'
  }

  const { isRatio, ...rest } = config
  const options: Intl.NumberFormatOptions = {
    style: 'percent',
    ...rest
  }

  return numberFormat(isRatio ? value : value / 100, options)
}

export default percentageFormat
